module.exports = __webpack_public_path__ + "bin/a0b4d495932f233fcaf2fa97560bac18.jpg";